import React from "react";
import { Gavel, FolderKanban, CalendarClock, FileCheck2, Users, BarChart3 } from "lucide-react";

const ITEMS = [
  {
    icon: Gavel,
    title: "Court diary & daily board",
    desc: "Your day sorted by court, item number and stage. Mark adjournments and next dates as you leave the room.",
  },
  {
    icon: FolderKanban,
    title: "Case management",
    desc: "Full records with CNR number, court, judge, opposing counsel, filing date, client and a dated hearing history.",
  },
  {
    icon: CalendarClock,
    title: "Hearings & reminders",
    desc: "A calendar of every listing with reminders before the date, so a rejoinder or appearance never slips.",
  },
  {
    icon: FileCheck2,
    title: "Private document storage",
    desc: "Petitions, affidavits and exhibits attached to the case they belong to. Served only to signed-in members of your firm.",
  },
  {
    icon: Users,
    title: "Client portal",
    desc: "Give a client read-only sight of their own matter and its updates — nothing else in your practice is visible.",
  },
  {
    icon: BarChart3,
    title: "Reports & CSV export",
    desc: "Case load, hearing and task reports for the chamber, exportable to CSV for your own records.",
  },
];

export const Features = () => (
  <section
    id="features"
    data-testid="landing-features"
    className="border-b border-border bg-white px-4 py-16 sm:px-6 sm:py-20 lg:px-8"
  >
    <div className="mx-auto max-w-6xl">
      <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark">
        What you get
      </p>
      <h2 className="mt-3 max-w-2xl font-display text-3xl font-semibold tracking-tight text-navy sm:text-4xl">
        Built around how litigation actually runs
      </h2>

      <div className="mt-12 grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map(({ icon: Icon, title, desc }) => (
          <div key={title} data-testid={`feature-${title.split(" ")[0].toLowerCase()}`} className="group">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-navy text-gold transition-transform group-hover:-translate-y-0.5">
              <Icon className="h-5 w-5" strokeWidth={1.75} />
            </span>
            <h3 className="mt-4 font-display text-xl text-navy">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
